import { createAction, props } from "@ngrx/store";

export const setRoles = createAction (
  '[Auth] Set Roles',
  props<{roles: string[]}>()
);

export const setPermissions = createAction(
  '[Auth] Set Permissions',
  props<{permissions: string[]}>()
);

export const setAgent = createAction(
  '[Auth] load Agent',
  props<{agent: string[]}>()
)

export const loadAgency = createAction(
  '[Agency] Load Agency',
  props<{ clientId: number }>()
);

export const setAgency = createAction(
  '[Agency] Set Agency',
  props<{ agency: string[] }>()
);

// Categories

export const setCategories = createAction(
  '[Categories] Set Categories',
  props<{ categories: string[] }>()
);

export const loadCurrencyById = createAction(
  '[Currency] Load Currency By Id',
  props<{ id: number }>()
);

export const setCurrency = createAction(
  '[Currency] Set Currency',
  props<{ currency: string[] }>()
);

// En tu archivo de acciones
export const setCategoriesClientSystem = createAction(
  '[Categories] Set Categories client system',
  props<{ clientId: number }>()
);

// ✅ Agregar esta acción para el éxito
export const setCategoriesClientSystemSuccess = createAction(
  '[Categories] Set Categories client system Success',
  props<{ categories: any[] }>()
);

// ✅ Agregar esta acción para el error
export const setCategoriesClientSystemFailure = createAction(
  '[Categories] Set Categories client system Failure',
  props<{ error: any }>()
);

export const clearAuthState = createAction('[Auth] Clear State');
